import { Typography, type TypographyProps } from "@mui/material";

function formatTimeAgo(dateStr: string): string {
  const now = new Date();
  const date = new Date(dateStr);
  const diffMs = now.getTime() - date.getTime();
  const diffMin = Math.floor(diffMs / 60000);
  const diffHr = Math.floor(diffMs / 3600000);
  const diffDay = Math.floor(diffMs / 86400000);

  if (diffMin < 1) return "upravo sada";
  if (diffMin < 60) return `prije ${diffMin} min`;
  if (diffHr < 24) return `prije ${diffHr}h`;
  if (diffDay < 7) return `prije ${diffDay}d`;

  return date.toLocaleDateString("hr-HR", {
    day: "numeric",
    month: "short",
    year: diffDay > 365 ? "numeric" : undefined,
  });
}

export function TimeAgo({
  date,
  ...props
}: { date: string } & Omit<TypographyProps, "children">) {
  return (
    <Typography
      variant="caption"
      {...props}
      sx={[
        {
          color: "text.secondary",
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    >
      {formatTimeAgo(date)}
    </Typography>
  );
}
